/**
 * Creates a Promise that resolves after a specified delay.
 *
 * @param {number} [delay=500] - The delay in milliseconds. Default is 500 milliseconds.
 * @returns {Promise<void>} A Promise that resolves after the specified delay.
 */
const timeout = (delay = 500) => {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
};

export default timeout;
